import { SubmissionErrors } from 'final-form';
import { FC } from 'react';
import { Col } from 'antd';
import { useTranslation } from 'react-i18next';

import { Survey } from '~src/modules/surveys/interfaces';
import { SurveySubjectTypes } from '~src/interfaces/surveys.interfaces';

import TopicQuestionsForm, { TopicValueI } from './TopicQuestionsForm';
import { SurveyTopicContainer, SurveyTopicTitle } from './topicSelect.sc';

interface OwnProps {
  changeQuestionCount: (count: number) => void;
  survey: Survey;
  surveyId: string;
  questionCount: number;
  isNewSurvey: boolean;
  saveSurvey: (formData: TopicValueI) => Promise<SubmissionErrors | void>;
}

const TopicSelect: FC<OwnProps> = (props) => {
  const [t] = useTranslation();
  const subjectKey =
    props.survey && props.survey.subject === SurveySubjectTypes.People ? `.${props.survey.useCase}` : '';
  const surveyTopicTitle = `x.surveys.details.select_question.title.${
    props.survey ? props.survey.subject : ''
  }${subjectKey}`;

  return (
    <SurveyTopicContainer>
      <Col lg={24}>
        <SurveyTopicTitle data-translation={surveyTopicTitle}>{t(surveyTopicTitle)}</SurveyTopicTitle>
        <TopicQuestionsForm
          isNewSurvey={props.isNewSurvey}
          survey={props.survey}
          surveyId={props.surveyId}
          changeQuestionCount={props.changeQuestionCount}
          onFormSubmit={props.saveSurvey}
          questionCount={props.questionCount}
        />
      </Col>
    </SurveyTopicContainer>
  );
};

export default TopicSelect;
